import { render, staticRenderFns } from "./PageThree.vue?vue&type=template&id=6308eb12&scoped=true&"
import script from "./PageThree.vue?vue&type=script&lang=ts&"
export * from "./PageThree.vue?vue&type=script&lang=ts&"
import style0 from "./PageThree.vue?vue&type=style&index=0&id=6308eb12&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6308eb12",
  null
  
)

export default component.exports